import gql from 'graphql-tag'

const updateFreelancerHoursAvailableMutation = gql`
  mutation updateFreelancerHoursAvailable($freelancerId: Int!, $hoursAvailable: Int!) {
    updateFreelancerHoursAvailable(freelancerId: $freelancerId, hoursAvailable: $hoursAvailable) {
      id
      hoursAvailable
    }
  }
`

export default updateFreelancerHoursAvailableMutation
